import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ApiConfig } from '@employee-configs/api.config';

@Component({
  selector: 'employee-view-matched-employees',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-matched-employees.component.html',
  styleUrl: './view-matched-employees.component.less'
})
export class ViewMatchedEmployeesComponent {

  constructor(
    public modalRef: BsModalRef,
    private http: HttpClient, 
    private sanitizer: DomSanitizer
  ) { }
  selectedItem:any;
  matchedItems:any[] = [];
  ngOnInit(): void {

    console.log(this.selectedItem);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      
    });
    //var raisedRequestsUrl = 'https://cognito.dbadge.deloitte.com/employee/api/photo/matchedDetails?requestId=' + this.selectedItem.requestId; 
    //var raisedRequestsUrl = 'https://localhost:5001/api/photo/matchedDetails?requestId=' + this.selectedItem.requestId; 
    var raisedRequestsUrl = ApiConfig.EmployeeSearch.getMatchedDetails + this.selectedItem.requestId; 
    this.http.get(raisedRequestsUrl, {headers:headers}).subscribe(
      (result:any[]) => {
        if(result != null && result != undefined) {
          console.log(result);
          this.matchedItems = result;
        }
      }, ()=> {}, ()=> {
        console.log('here');
      }
    );

  }

  close() {
    this.modalRef.hide();
  }

  getSafeImageUrl(base64: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(`${base64}`);
  }


}
